function n(t){return t!==null&&(typeof t=="object"||typeof t=="function")}export{n as isObject};
